import { Formik } from "formik";
import { InstructionsPage } from "../../../Registration/InstructionsPage/InstructionsPage";
import Input from "../../../shared/Input/Input";
import Button from "@mui/material/Button";
import { useLazyValidateBpSiteIdQuery } from "../../../../services/rtkQueryServices/authenticationService";
import { useState } from "react";
import { LOGIN_LITERALS } from "../../../../constants/literals";
import { useAuth } from "../../../../context/AuthProvider";
import { Roles } from "../../../../constants/data/Roles";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { errorMessages } from "../../../../constants/errorMessages";
import Textarea from "../../../shared/TextArea/TextArea";
import { validate } from "uuid";
export const BpSiteIdVerificationHandler = (props: any) => {
  const [validateBpSiteId] = useLazyValidateBpSiteIdQuery();
  const [errorMessage, setErrorMessage] = useState<string>("");
  const auth = useAuth();
  const { applicationUserId } = useParams();

  let userId =
    auth?.authClaims?.role === Roles.clinicAdmin
      ? auth?.authClaims?.applicationUserId
      : applicationUserId;
  const validationSchema = () =>
    Yup.object({
      bpSiteId: Yup.string().required(errorMessages.required("BP Site ID")),
      haloGuid: Yup.string()
        .test("is-valid-uuid", errorMessages.invalidGuidFormat, (value) =>
          value ? validate(value) : false
        )
        .required(errorMessages.required("Halo GUID"))
        .min(36, errorMessages.characterLimit("Halo GUID", 36))
        .max(36, errorMessages.characterLimit("Halo GUID", 36)),
      PracticeVerificationInformation:
        auth?.authClaims?.role === Roles.clinicAdmin
          ? Yup.string().notRequired()
          : Yup.string()
              .required(
                errorMessages.required("Practice Verification Information")
              )
              .min(
                12,
                errorMessages.minCharacterLimit(
                  "Practice Verification Information",
                  12
                )
              ),
    });
  return (
    <>
      <div className="pt-2">
        <Formik
          initialValues={{
            bpSiteId: "",
            haloGuid: "",
            PracticeVerificationInformation: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            validateBpSiteId({
              bpSiteId: values.bpSiteId,
              haloGuid: values.haloGuid,
              PracticeVerificationInformation:
                values.PracticeVerificationInformation,
              applicationUserId: userId,
            }).then((res) => {
              if (
                res.isSuccess &&
                res.data?.data?.isValidBpSiteId &&
                res.data?.data?.isValidHaloGuid &&
                res.data?.data?.isSuccessfulSqlConnection
              ) {
                props.onClose();
              } else if (res.isSuccess && !res?.data?.data) {
                setErrorMessage(LOGIN_LITERALS.somethingWentWrong);
              } else if (res.isSuccess) {
                if (!res.data?.data?.isValidBpSiteId || !res.data?.data?.isValidHaloGuid) {
                  setErrorMessage(errorMessages.invalid_BPSiteID_or_HaloGUID);
                } else if (!res.data?.data?.isSuccessfulSqlConnection) {
                  setErrorMessage(errorMessages.cannot_connect_to_BP);
                }
              } else if (res.isError) {
                setErrorMessage(
                  (res.error as any)?.data?.message ||
                    LOGIN_LITERALS.somethingWentWrong
                );
              }
            });
          }}
        >
          {(formik) => (
            <form
              //   onKeyDown={Utility.preventSubmitOnEnter}
              onSubmit={formik.handleSubmit}
              className="d-flex flex-column registration-form instructions-container align-items-center"
            >
              <InstructionsPage />
              <div className="pt-3 w-75 bp-site-input">
                <Input
                  name="bpSiteId"
                  placeholder="BP Site ID"
                  onChange={formik.handleChange}
                  onInput={() => {
                    setErrorMessage("");
                  }}
                  value={formik.values.bpSiteId}
                  errorMsg={
                    (formik.touched.bpSiteId || formik.submitCount > 0) &&
                    formik.errors.bpSiteId &&
                    (formik.errors as any).bpSiteId
                  }
                  maxLength={64}
                  label="BP Site ID"
                  required
                />
                <Input
                  name="haloGuid"
                  placeholder="Halo GUID"
                  onChange={formik.handleChange}
                  onInput={() => {
                    setErrorMessage("");
                  }}
                  value={formik.values.haloGuid}
                  errorMsg={
                    (formik.touched.haloGuid || formik.submitCount > 0) &&
                    formik.errors.haloGuid &&
                    (formik.errors as any).haloGuid
                  }
                  maxLength={64}
                  label="Halo GUID"
                  required
                />
                {(auth?.authClaims?.role === Roles.supportUser ||
                  auth?.authClaims?.role === Roles.superUser) && (
                  <Textarea
                    name="PracticeVerificationInformation"
                    className="text-area"
                    autoFocus={false}
                    value={formik.values.PracticeVerificationInformation}
                    onChange={formik.handleChange}
                    label={"Practice Verification Information"}
                    placeHolder="Please share the details of how the HALO GUID was acquired."
                    onBlur={formik.handleBlur}
                    errorMessage={
                      (formik.touched.PracticeVerificationInformation ||
                        formik.submitCount > 0) &&
                      formik.errors.PracticeVerificationInformation &&
                      (formik.errors as any).PracticeVerificationInformation
                    }
                    required
                  ></Textarea>
                )}
              </div>
              {errorMessage && (
                <div className="pt-3 w-75 error-message align-self-center">
                  {errorMessage}
                </div>
              )}

              <div className="d-flex justify-content-end flex-column gap-3 line-top py-3 registration-form-button register-submission">
                <Button
                  variant="contained"
                  type="submit"
                  disabled={!formik.isValid || !formik.dirty}
                >
                  Submit
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
};
